import React from 'react';
import styled from 'styled-components';

export const CabinetWidgetTemplate = ({ balance, license, profile }) => (
  <Container>
    <BalanceContainer>
      <MenuContainer>{license}</MenuContainer>
      <MenuContainer>{balance}</MenuContainer>
    </BalanceContainer>
    <ProfileContainer>{profile}</ProfileContainer>
  </Container>
);

const Container = styled.div``;

const MenuContainer = styled.div``;

const ProfileContainer = styled.div`
  position: absolute;
  right: 0;
  width: 190px;
`;

const BalanceContainer = styled.div`
  position: absolute;
  right: 195px;
  width: 270px;
  flex-direction: column;
`;
